import ReactDOMServer from 'react-dom/server';
import SalesPitchTextContainer from './sales-pitch-text-container';
import SavingsV2Pill from '../savings-v2-pill';
import Spacer from '@/common/components/spacer';
import { cn } from '@/shadcn-ui/utils';
import SavingsV2SalesPitchGradient from '@/icons/calculator-sales-pitch-v2-gradient';
import SavingsCostComparisonTable from '../savings-calculator-v2/savings-cost-comparison-table';
export interface CalculatorSalesPitchV2Props {
  buyingUpfront: number;
  buyingMonthlyCar: number;
  buyingMonthlyInsurance: number;
  flexcarUpfront: number;
  flexcarMonthlyCar: number;
  flexcarMonthlyInsurance: number;
  flexcarShippingCost?: number;
  flexcarNewCarSurcharge?: number;
  flexcarMembershipCost?: number;
  PUBLIC_CDN_URL: string;
  isOnPDP: boolean;
  handleOpen: () => void;
}

export default function CalculatorSalesPitchV2({
  buyingUpfront,
  buyingMonthlyCar,
  buyingMonthlyInsurance,
  flexcarUpfront,
  flexcarMonthlyCar,
  flexcarMonthlyInsurance,
  flexcarShippingCost,
  flexcarNewCarSurcharge,
  flexcarMembershipCost,
  isOnPDP,
  handleOpen,
}: CalculatorSalesPitchV2Props) {
  const gradientBackground = encodeURIComponent(
    ReactDOMServer.renderToStaticMarkup(<SavingsV2SalesPitchGradient />)
  );

  return (
    <>
      <div className="group rounded-3xl bg-white">
        <SalesPitchTextContainer
          isOnPDP={isOnPDP}
          showSavings={true}
          showSavingsCalculatorV2={true}
          className={cn(
            'bg-[image:var(--background-gradient)] bg-cover bg-center bg-no-repeat',
            {
              'max-[378px]:bg-[position:right_17px] max-[1024px]:min-[673px]:bg-[position:right_-15px]':
                isOnPDP,
              'max-[426px]:bg-[position:right_17px] max-[768px]:min-[721px]:bg-[position:right_-15px]':
                !isOnPDP,
            }
          )}
          style={
            {
              '--background-gradient': `url("data:image/svg+xml,${gradientBackground}")`,
            } as React.CSSProperties
          }
        >
          <div className="flex w-full flex-col">
            <div className="flex w-full cursor-pointer flex-col items-center">
              <SavingsCostComparisonTable
                buyingUpfront={buyingUpfront}
                buyingMonthlyCar={buyingMonthlyCar}
                buyingMonthlyInsurance={buyingMonthlyInsurance}
                flexcarUpfront={flexcarUpfront}
                flexcarMonthlyCar={flexcarMonthlyCar}
                flexcarMonthlyInsurance={flexcarMonthlyInsurance}
                flexcarShippingCost={flexcarShippingCost}
                flexcarNewCarSurcharge={flexcarNewCarSurcharge}
                flexcarMembershipCost={flexcarMembershipCost}
              />
              <Spacer variant="height16" />

              <div
                className="flex w-full cursor-pointer flex-col items-center"
                role="button"
                tabIndex={0}
                onClick={handleOpen}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    handleOpen();
                  }
                }}
              >
                <SavingsV2Pill
                  text="Flexcar Savings Calculator"
                  permanentShadow={false}
                  className="flex h-[48px] w-full sm:w-[302px]"
                  animationDuration="duration-300"
                  contentClassName="px-[16px]"
                  textClassName="body-strong"
                />
              </div>
            </div>
          </div>
        </SalesPitchTextContainer>
      </div>
    </>
  );
}
